import React from 'react';
import Modal from 'react-modal';

if (typeof document !== 'undefined')
    Modal.setAppElement(document.querySelector('.account-container') ? '.account-container' : 'body');

export const closeTimeoutMS = 100;

const modalConfig = {
    className: {
        base: 'modal-dialog modal-dialog--shadow',
        afterOpen: 'modal-dialog--visible modal-dialog--entering modal-dialog--auto-width',
        beforeClose: 'modal-dialog--visible'
    },
    overlayClassName: {
        base: 'modal-dialog-clickeater',
        afterOpen: 'modal-dialog-clickeater--entering',
        beforeClose: 'modal-dialog-clickeater--exiting'
    },
    closeTimeoutMS
};

const ModalDialog = props => {
    const { isOpen, onRequestClose, header, theme, width, height, ...rest } = props;
    const localModalConfig = JSON.parse(JSON.stringify(modalConfig));

    let headerClass = "modal-dialog__header",
        buttonClass = "modal-dialog__close-button";

    if (theme === "active") 
        headerClass += " background--active-blue";
    if (theme === "positive")
        headerClass += " background--success-green";
    if (theme === "negative")
        headerClass += " background--error-red"

    if (theme === "active" || theme === "positive" || theme === "negative") {
        headerClass += " text--white";
        buttonClass += " modal-dialog__close-button--light";
    }

    if (theme === "helix-unlock") {
        localModalConfig.className.base += " modal-dialog--helix-variant";
    }

    const styleConfig = {
        content: {
            width: typeof width === "number" ? `${width}px` : "",
            height: typeof height === "number" ? `${height}px` : ""
        }
    };

    return <Modal isOpen={isOpen} {...localModalConfig} {...rest}
        style={styleConfig}
        onRequestClose={onRequestClose}>
        <header className={headerClass}>
            <button type="button" className={buttonClass} onClick={onRequestClose}>Close</button>
            <span>{header}</span>
        </header>
        <div className="modal-dialog__content">{props.children}</div>
    </Modal>
}

export default ModalDialog;
